import useDocumentTitle from 'hooks/useDocumentTitle';
import React from 'react'

const MaterialGroup = () => {
  useDocumentTitle("Material Category | T360");

  return (
    <div>MaterialGroup</div>
  )
}

export default MaterialGroup